import React, { useRef, useState } from "react";
import { Switch, Route } from "react-router-dom";
import InfoPage from "./Components/InfoPage";
import Predeparture from "./Components/Predeparture";
import ErrorPage from "./Components/ErrorPage";
import Logo1 from "./assets/logo-.png";
import Logo2 from "./assets/logo2.jpg";
import Navbar from "./Components/Navbar";
import { useOnClickOutside } from "./hooks";
import { useMediaQuery } from "react-responsive";

function App() {
    const [open, setOpen] = useState(false);

    const isTabletOrMobile = useMediaQuery({
        query: "(max-width: 769px)",
    });

    const ref = useRef();
    useOnClickOutside(ref, () => setOpen(false), open);

    return (
        <>
            {isTabletOrMobile ? (
                <div ref={ref} style={HeaderStyle["app-bar"]}>
                    {/* mobbile tablet view */}
                    <img style={HeaderStyle["logo-small-view"]} src={Logo1} alt="header-log" />
                    <div onClick={() => setOpen(!open)} className={`menu-btn ${open ? "open" : ""}`}>
                        <div className="menu-btn__burger"></div>
                    </div>
                </div>
            ) : (
                <div className="header-wrapper">
                    {/* desktop view */}
                    <div className="app-header">
                        <div className="logo-wrapper">
                            <img className="logo logo1" src={Logo1} alt="header-logo" />
                        </div>
                        <div className="header-info"> Pre Departure</div>
                        {/* <img className="logo logo2" src={Logo2} /> */}
                    </div>
                </div>
            )}

            {open && <div className="layer" />}

            {isTabletOrMobile && (
                <div className="hero-section">
                    <img className="hero-img" src={Logo2} alt="banner-img" />
                </div>
            )}

            <div className="container">
                <Navbar setOpen={setOpen} open={open} reference={ref} isTabletOrMobile={isTabletOrMobile} />
                <Switch>
                    <Route path="/error" component={ErrorPage} />
                    <Route path="/:tourId" render={routeParams => <Predeparture routeParams={routeParams} />} />
                    <Route path="/" component={InfoPage} />
                </Switch>
            </div>
        </>
    );
}

const HeaderStyle = {
    "app-bar": {
        position: "sticky",
        top: "0",
        marginLeft: "0",
        marginRight: "0",
        padding: "0 1rem",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        /* margin-bottom: var(--mb-1-5); */
        backgroundColor: "#21252b",
        height: "70px",
        zIndex: "101",
        boxShadow: "0 2px 2px rgba(0, 0, 0, 0.15)",
    },
    "logo-small-view": {
        width: "230px",
    },
};

export default App;
